import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("path", {
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 18h16M4 6h16H4Zm0 6h8-8Z",
        }),
      ]
    )
  );
}
